import { render, staticRenderFns } from "./DisputeLetters.vue?vue&type=template&id=44fd536d&"
import script from "./DisputeLetters.vue?vue&type=script&lang=js&"
export * from "./DisputeLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports